import styled from 'styled-components';

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
`;

export const TableHead = styled.thead``;

export const TableRow = styled.tr`
  background-color: ${(props) => (props.header ? '#4b286d' : props.striped ? '#f9f9f9' : '#fff')};
  color: ${(props) => (props.header ? '#ffffff' : 'inherit')};
`;

export const TableBody = styled.tbody``;

export const TableCell = styled.td`
  padding: 12px;
  text-align: center;
  font-size: 14px;
  font-weight: ${(props) => (props.header ? 'bold' : 'normal')};
`;
